import { Box } from 'foundations-components/transitional/components/Box';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import TimelineLine from './TimelineLine';
import TimelinePill from './TimelinePill';
import { LEFT_COL_WIDTH, RIGHT_COL_WIDTH } from '../../constants/MediaTimelinePositioning';
import { MEDIA_PLAYER_COLORS } from '../../constants/Colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Timeline = props => {
  const {
    timelineName,
    leftColContent,
    rightColContent,
    pills
  } = props;
  return /*#__PURE__*/_jsxs(Flex, {
    display: "inline-flex",
    inlineSize: "100%",
    "data-test-id": "mediaTimeline-timeline",
    children: [/*#__PURE__*/_jsx(Box, {
      basis: LEFT_COL_WIDTH,
      shrink: 0,
      grow: 0,
      paddingInlineEnd: "300",
      minBlockSize: "24px",
      children: /*#__PURE__*/_jsx(Text, {
        display: "block",
        as: "div",
        textAlign: "start",
        color: MEDIA_PLAYER_COLORS.TIMELINE_TEXT_COLOR_ALT,
        children: leftColContent
      })
    }), /*#__PURE__*/_jsx(Box, {
      grow: 1,
      children: /*#__PURE__*/_jsx(TimelineLine, {
        children: pills.map((pill, index) => /*#__PURE__*/_jsx(TimelinePill, {
          pill: pill
        }, `${timelineName}-${index}`))
      })
    }), /*#__PURE__*/_jsx(Box, {
      basis: RIGHT_COL_WIDTH,
      shrink: 0,
      grow: 0,
      paddingInlineStart: "300",
      minBlockSize: "24px",
      children: /*#__PURE__*/_jsx(Text, {
        display: "block",
        as: "div",
        textAlign: "end",
        color: MEDIA_PLAYER_COLORS.TIMELINE_TEXT_COLOR_ALT,
        children: rightColContent
      })
    })]
  });
};
export default Timeline;